import { useSavedLocationListApi } from '@hero/api-hooks';
import { getObjectId } from '@hero/schema';

export interface UseSavedLocationsListOptions {
  /** Whether the query is enabled */
  enabled?: boolean;
  /** Limit per page */
  limit?: number;
  /** Client ID for filtering (the third-party counterparty, NOT the user's own Org). */
  clientId?: string;
  /** Filter by own branch only */
  isOwnBranch?: boolean;
}

/**
 * Hook to fetch saved locations list with pagination.
 * Uses useSavedLocationListApi() internally.
 */
export function useSavedLocationsList(options: UseSavedLocationsListOptions) {
  const { enabled = true, limit = 5, clientId, isOwnBranch } = options;

  const { data, onLoadMore, hasNextPage, isFetchingNextPage, isLoading, error } =
    useSavedLocationListApi(
      { clientId: clientId ? getObjectId(clientId) : undefined, isOwnBranch },
      { limit, enabled },
    );

  return {
    data,
    onLoadMore,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    error,
  };
}
